import {
  Country,
  formatPhoneNumberIntl,
  getCountryCallingCode,
  isSupportedCountry,
  parsePhoneNumber
} from 'react-phone-number-input';

// Whitespace (including non-breaking spaces) and zero-width characters
const IGNORED_CHARACTERS = /[\s\u200B-\u200D\u2060\uFEFF]/g;

// An optional leading "+", then only digits and ( ) - .
const PHONE_CHARACTERS = /^\+?[\d().-]+$/;

const FALLBACK_COUNTRY: Country = 'US';

export function normalizeLoginInput(value?: string | null) {
  return (value ?? '').replace(IGNORED_CHARACTERS, '');
}

export function isPhoneLike(value: string) {
  return PHONE_CHARACTERS.test(value) && /\d/.test(value);
}

export function isEmailLike(value: string) {
  return value.includes('@');
}

export function getDefaultPhoneCountry(): Country {
  const languages =
    typeof navigator === 'undefined' ? [] : (navigator.languages ?? []);

  for (const language of languages) {
    try {
      const region = new Intl.Locale(language).region;

      if (region && isSupportedCountry(region)) {
        return region as Country;
      }
    } catch {}
  }

  return FALLBACK_COUNTRY;
}

export function toInternationalPhone(
  value: string,
  defaultCountry: Country = getDefaultPhoneCountry()
) {
  const parsed = parsePhoneNumber(value, defaultCountry);

  if (parsed) {
    return parsed.number as string;
  }

  const digits = value.replace(/\D/g, '');

  return value.startsWith('+')
    ? `+${digits}`
    : `+${getCountryCallingCode(defaultCountry)}${digits}`;
}

export function formatLoginIdentifier(value: string) {
  return value.startsWith('+') ? formatPhoneNumberIntl(value) || value : value;
}

export function joinIds(...ids: (string | false | null | undefined)[]) {
  return ids.filter(Boolean).join(' ') || undefined;
}
